<div class="main-page-content">
    <h1>Impressum</h1>
    
    <div class="section">
        <p>
            <strong>Westfalen Weser Netz GmbH</strong>
            <br> Unternehmenssitz 
            <br> Tegelweg 25
            <br> 33102 Paderborn
        </p>
    </div>
    
    <div class="section">
        <p>
            <strong>Unser Service:</strong>
            <br> T +49 5251 202 0303 
            <br> <a href="mailto:info@ww-energie.com">info@ww-energie.com</a>
            <br> F +49 5251 503 4367
        </p>
    </div>

    <div class="section">
        <p>
            <strong>Geschäftsführer:</strong>
            <br> Andreas Speith
        </p>
    </div>

    <div class="section">
        <p>
            <strong>Verantwortlicher gemäß § 55 Abs. 2 RStV:</strong>
            <br> Mike Süggeler
            <br> Redaktion:
            <br> Andreas Stoller
        </p>
        <p>
            Sitz Paderborn, Handelsregister Amtsgericht Paderborn, HRB 11572
            <br> USt-ID-Nr.: DE 126 229 505
        </p>
    </div>
    
    <div class="section">
        <p>
            <strong>Aufsichtsbehörde:</strong>
            <br> Bundesnetzagentur für Elektrizität, Gas, Telekommunikation, Post und Eisenbahnen
        </p>
        <p>
            <br> Tulpenfeld 4, 53113 Bonn
            <br> Postfach 80 01, 53105 Bonn
            <br> T +49 228 140
            <br> F +49 228 148 872
            <br> E-Mail: <a href="mailto:info@bnetza.de">info@bnetza.de</a>
            <br> <a href="https://www.bundesnetzagentur.de">www.bundesnetzagentur.de</a>
            <br> 
        </p>
    </div>

    <div class="section">
        <p>
            <strong>Konzeption, Design und Realisierung</strong>
            <br> Westfalen Weser Energie in Zusammenarbeit mit
            <br> agilecore | software engineering | bronnikow
            <br> Max Bronnikow
        </p>
    </div>

</div>
